export default "/arbitrum.f1b36c5840bc59352db494f2db253c75.svg";